import { httpClient } from '../lib/httpClient';

// Client Profile
export async function generateClientProfile(clientId: string) {
  return httpClient.post(`/api/kyc/${clientId}/generate-client-profile`);
}

export async function saveClientProfile(clientId: string, data: Record<string, unknown>) {
  return httpClient.put(`/api/kyc/${clientId}/client-profile`, data);
}

export async function getClientProfile(clientId: string) {
  return httpClient.get(`/api/kyc/${clientId}/client-profile`);
}

// Form A
export async function generateFormA(clientId: string) {
  return httpClient.post(`/api/kyc/${clientId}/generate-form-a`);
}

export async function saveFormA(clientId: string, data: Record<string, unknown>) {
  return httpClient.put(`/api/kyc/${clientId}/form-a`, data);
}

export async function getFormA(clientId: string) {
  return httpClient.get(`/api/kyc/${clientId}/form-a`);
}

// Risk Profile Prefill
export async function prefillRiskProfile(clientId: string) {
  return httpClient.post(`/api/kyc/${clientId}/prefill-risk-profile`);
}
